import { render, staticRenderFns } from "./listHavoblogComments.vue?vue&type=template&id=67d197e4&"
import script from "./listHavoblogComments.vue?vue&type=script&lang=js&"
export * from "./listHavoblogComments.vue?vue&type=script&lang=js&"
import style0 from "./listHavoblogComments.vue?vue&type=style&index=0&id=67d197e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports